import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const SortArrow = styled(FontAwesomeIcon)`
  height: 0.75rem;
  color: rgb(0, 0, 0, 0.54);
`;
